import axiosInstance from 'services/axiosInstance';
import { IResponse } from 'services/types';
import { IMyPricePlan, IPricePlan } from 'services/pricePlan/types';

export const getMyPricePlan = (): IResponse<IMyPricePlan> =>
  axiosInstance.request({ method: 'GET', url: 'PricePlan/myPlan' });

export const getPricePlans = (): IResponse<IPricePlan[]> =>
  axiosInstance.request({ method: 'GET', url: 'PricePlan' });
